import FormControl from '@mui/joy/FormControl';
import FormHelperText from '@mui/joy/FormHelperText';
import FormLabel from '@mui/joy/FormLabel';
import Input, { InputTypeMap } from '@mui/joy/Input';

import { ReactNode } from 'react';

type TextFieldProps = InputTypeMap['props'] & {
  label?: ReactNode;
  helperText?: string | boolean;
  helperTextStyle?: React.CSSProperties;
};

export function TextField({
  required,
  size,
  label,
  helperText,
  color,
  helperTextStyle,
  ...props
}: TextFieldProps) {
  return (
    <FormControl
      required={required}
      size={size}
      color={color}
      error={props.error}
    >
      {label && <FormLabel>{label}</FormLabel>}
      <Input name="hello" {...props} />
      {helperText && (
        <FormHelperText style={helperTextStyle}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
